export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  reviewUpdateSuccess: 'Review was successfully updated.',
  reviewUpdateFailure: 'Review was not updated. You may not own this review.',
  reviewDeleteSuccess: 'Review was successfully deleted.',
  reviewDeleteFailure: 'Review was not deleted. You may not own this review.',
  reviewCreateSuccess: 'Review was successfully created. Thank you for your contribution!',
  reviewCreateFailure: 'Review was not created. Please check all fields.',
  gameCreateSuccess: 'Game was successfully created. Thank you for your contribution!',
  gameCreateFailure: 'Game was not created. Please check all fields.',
  tagCreateSuccess: 'Tag was added. Thank you for your contribution!',
  tagCreateFailure: 'Tag was not added. Please try signing out and in.',
  tagDeleteSuccess: 'Tag was removed. Thank you for your contribution!',
  tagDeleteFailure: 'Tag was not removed. Please try signing out and in.'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js